export const DIALOG_TYPE_ADD = "0";
export const DIALOG_TYPE_UPDATE = "1";
export const DIALOG_TYPE_DELETE = "2";
export const DIALOG_TYPE_VIEW = "3";
//待审核
export const APPROVE_STATUS_NOT = "0";
//已通过
export const APPROVE_STATUS_AGREE = "1";
//已拒绝
export const APPROVE_STATUS_REFUSE = "2";
export const constARTICLE_CASE_SHARE_TYPE_CODE = "044-003";
//病例讨论
export const ARTICLE_CASE_DISCUSS_TYPE_CODE = "044-004";
//card的高度常数
export const CARD_HEIGHT_TYPE = 115;

export const TAB_HEIGHT_TYPE = 81;

//每页数据大小
export const PAGE_SIZE_TYPE = 13;

//页数据大小列表
export const PAGE_SIZE_ARRAY = [10, 20, 30, 40, 50];

// export const SHOW_HEIGHT_TYPE = 150;
//
// export const REGISTER_TAB_HEIGHT_TYPE = 200;
//
// export const REGISTER_HEIGHT_TYPE = 100;

export const ATTA_FILE_SUF_LIST = [
  "jpg",
  "png",
  "gif",
  "jpeg",
  "psd",
  "pdf",
  "ppt",
  "pptx",
  "doc",
  "docx",
  "xlsx",
  "xls",
  "txt"
];

export const ATTA_UPLOAD_COMPONENT_TYPE_STR =
  ".jpg,.png,.gif,.jpeg,.psd,.pdf,.ppt,.pptx,.doc,.docx,.xlsx,.xls,.txt";

export const AVATAR_UPLOAD_COMPONENT_TYPE_STR = ".jpg,.png,.gif,.jpeg";

export const ATTA_UPLOAD_CASE_SHARE_TYPE_STR =
  ".excel,.xls,.xlsx,.ppt,.pptx,.pdf";

export const SINGLE_ATTACHMENT_MAX_SIZE = 10485760;

//省中医资料信息中表格显示条数
export const MEMBER_TABLEDATA_LENGTH = 7;

export const ATTA_FILE_SHOW_TYPE = {
  avi: "video/x-msvideo",
  azw: "application/vnd.amazon.ebook",
  bin: "application/octet-stream",
  bmp: "image/bmp",
  "bz	 ": "application/x-bzip",
  bz2: "application/x-bzip2",
  csh: "application/x-csh",
  css: "text/css",
  csv: "text/csv",
  gif: "image/gif",
  htm: "text/html",
  html: "text/html",
  ico: "image/vnd.microsoft.icon",
  ics: "text/calendar",
  jpeg: "image/jpeg",
  jpg: "image/jpeg",
  "js	 ": "text/javascript",
  json: "application/json",
  jsonld: "application/ld+json",
  "mid ": "audio/x-midi",
  midi: "audio/x-midi",
  mjs: "text/javascript",
  mp3: "audio/mpeg",
  mpeg: "video/mpeg",
  mpkg: "application/vnd.apple.installer+xml",
  odp: "application/vnd.oasis.opendocument.presentation",
  ods: "application/vnd.oasis.opendocument.spreadsheet",
  odt: "application/vnd.oasis.opendocument.text",
  oga: "audio/ogg",
  ogv: "video/ogg",
  ogx: "application/ogg",
  otf: "font	font/otf",
  png: "image/png",
  rtf: "application/rtf",
  "sh	 ": "application/x-sh",
  svg: "image/svg+xml",
  swf: "application/x-shockwave-flash",
  "tif ": "image/tiff",
  tiff: "image/tiff",
  //txt 如果是utf-8格式打开出现乱码的问题 如果是gbk可正常打开，这里为了避免这个问题，先暂时不让txt格式的文件预览了
  // 'txt'	:	'text/plain',
  vsd: "application/vnd.visio",
  wav: "audio/wav",
  weba: "audio/webm",
  webm: "video/webm",
  webp: "image/webp",
  woff: "font/woff",
  woff2: "font/woff2",
  xhtml: "application/xhtml+xml",
  xul: "application/vnd.mozilla.xul+xml",
  "3gpa": "audio/3gpp",
  "3gpv": "video/3gpp",
  "3g2v": "video/3gpp2",
  "3g2a": "audio/3gpp2",
  pdf: "application/pdf",
  ppt: "application/vnd.ms-powerpoint",
  pptx:
    "application/vnd.openxmlformats-officedocument.presentationml.presentation"
};

export const ATTA_FILE_DOWN_TYPE = {
  aac: "audio/aac",
  abw: "application/x-abiword",
  arc: "application/x-freearc",
  avi: "video/x-msvideo",
  azw: "application/vnd.amazon.ebook",
  bin: "application/octet-stream",
  bmp: "image/bmp",
  "bz	 ": "application/x-bzip",
  bz2: "application/x-bzip2",
  csh: "application/x-csh",
  css: "text/css",
  csv: "text/csv",
  doc: "application/msword",
  docx:
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  eot: "application/vnd.ms-fontobject",
  epub: "application/epub+zip",
  gif: "image/gif",
  htm: "text/html",
  html: "text/html",
  ico: "image/vnd.microsoft.icon",
  ics: "text/calendar",
  jar: "application/java-archive",
  jpeg: "image/jpeg",
  jpg: "image/jpeg",
  "js	 ": "text/javascript",
  json: "application/json",
  jsonld: "application/ld+json",
  "mid ": "audio/x-midi",
  midi: "audio/x-midi",
  mjs: "text/javascript",
  mp3: "audio/mpeg",
  mpeg: "video/mpeg",
  mpkg: "application/vnd.apple.installer+xml",
  odp: "application/vnd.oasis.opendocument.presentation",
  ods: "application/vnd.oasis.opendocument.spreadsheet",
  odt: "application/vnd.oasis.opendocument.text",
  oga: "audio/ogg",
  ogv: "video/ogg",
  ogx: "application/ogg",
  otf: "font	font/otf",
  png: "image/png",
  pdf: "application/pdf",
  ppt: "application/vnd.ms-powerpoint",
  pptx:
    "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  rar: "application/x-rar-compressed",
  rtf: "application/rtf",
  "sh	 ": "application/x-sh",
  svg: "image/svg+xml",
  swf: "application/x-shockwave-flash",
  tar: "application/x-tar",
  "tif ": "image/tiff",
  tiff: "image/tiff",
  ttf: "font/ttf",
  txt: "text/plain",
  vsd: "application/vnd.visio",
  wav: "audio/wav",
  weba: "audio/webm",
  webm: "video/webm",
  webp: "image/webp",
  woff: "font/woff",
  woff2: "font/woff2",
  xhtml: "application/xhtml+xml",
  xls: "application/vnd.ms-excel",
  xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  xml: "application/xml",
  xul: "application/vnd.mozilla.xul+xml",
  zip: "application/zip",
  "3gpa": "audio/3gpp",
  "3gpv": "video/3gpp",
  "3g2v": "video/3gpp2",
  "3g2a": "audio/3gpp2",
  "7z	 ": "application/x-7z-compressed"
};

//各码表其他值
export const PLATFORM_OTHER_CODE = "061-999";
export const LEVEL_OTHER_CODE = "039-999";
export const STU_OTHER_CODE = "059-999";
export const PRJLEVEL_OTHER_CODE = "058-999"; //获奖项目等级 其他
export const HUOJIANG_OTHER_CODE = "026-999"; //获奖类别 其他
export const HUOJIANG_LEVEL_OTHER_CODE = "027-999"; //获奖级别类别 其他
export const ZHUANLI_OTHER_CODE = "025-999";
export const MAJOR_OTHER_CODE = "049-999"; //医师资格证专业类别 其他
export const TYPE_OTHER_CODE = "047-999"; //医师执业证执业类别 其他
export const NATURE_OTHER_CODE = "030-999"; //带教性质 其他
export const STU_NATURE_OTHER_CODE = "031-999"; //带教参与人员性质 其他
export const RONGYU_LEVEL_OTHER_CODE = "042-999"; //个人荣誉称号奖励级别 其他
export const LUNWEN_NATURE_OTHER_CODE = "016-999"; //论文性质 其他
export const JOB_OTHER_CODE = "022-999"; //著作担任职务 其他
export const PUBLISHER_OTHER_CODE = "024-999"; //著作出版社 其他
export const SOCIETY_OTHER_CODE = "035-999"; //社会任职级别 其他
export const SOCIETY_JOB_OTHER_CODE = "036-999"; //社会任职 其他
export const YIZHEN_TYPE_OTHER_CODE = "037-999"; //义诊类型 其他
export const ATTEND_OTHER_CODE = "041-999"; //学术会议参会性质 其他
export const ATTEND_LEVEL_OTHER_CODE = "052-999"; //学术会议参会级别 其他



// WEBPACK FOOTER //
// ./src/constants/constants.js